<mat-form-field [appearance]="options?.appearance? options.appearance : 'standard'">
    <mat-label>{{options.title}}<span class="asterisk"
            *ngIf="utils.isRequiredField(formControlThirdPartyAddress)">*</span></mat-label>
    <input (keyup)="changeValue()" matInput [matAutocomplete]="autocompleteThirdParties"
        [formControl]="formControlThirdPartyAddress">
    <div matSuffix class="spinner-border text-info" role="status" *ngIf="loadingThirdParties">
        <span class="sr-only">Loading...</span>
    </div>
    <mat-autocomplete #autocompleteThirdParties="matAutocomplete" [displayWith]="displayThirdPartyName"
        (optionSelected)="onSelectAddress($event)">
        <mat-option [value]="null" (click)="openDialog()" *ngIf="showCreateAddress" permission-display
            [module]="permission.administration.module"
            [functionality]="permission.administration.createThirdPartyAddress">
            <span class="font-italic">Agregar {{options.title}}</span>
        </mat-option>
        <mat-option *ngFor="let thirdPartyAddress of thirdPartiesAddressesFiltered" [value]="thirdPartyAddress"
            [disabled]="utils.disableThirdPartyAddress(thirdPartyAddress).disable"
            [matTooltip]="utils.disableThirdPartyAddress(thirdPartyAddress).reason" matTooltipClass="tooltip__error">
            <span>{{ thirdPartyAddress?.branchOfficeName? thirdPartyAddress?.branchOfficeName :
                thirdPartyAddress?.address?.address}}</span>
        </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="formControlThirdPartyAddress.errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
    <mat-hint
        *ngIf="inputFormControl?.value?.address && (!inputFormControl?.value?.address?.location?.lat || !inputFormControl?.value?.address?.location?.lng)"
        class="color-secondary-dark text-bold">La dirección
        seleccionada requiere <u class="cursor-pointer" (click)="openAddLatLng()">asociar longitud y
            latitud</u></mat-hint>
    <mat-hint
        *ngIf="inputFormControl?.value?.address && inputFormControl?.value?.address?.location?.lat && inputFormControl?.value?.address?.location?.lng && options?.showEditAddress"
        class="color-secondary-dark text-bold cursor-pointer" (click)="editThirdPartyAddressDialog()">
        <i class="fas fa-edit"></i> Editar dirección
    </mat-hint>
</mat-form-field>